import { render } from "./viewContainer.vue?vue&type=template&id=ff985146&scoped=true"
import script from "./viewContainer.vue?vue&type=script&lang=js"
export * from "./viewContainer.vue?vue&type=script&lang=js"

import "./viewContainer.vue?vue&type=style&index=0&id=ff985146&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-new-front.rule.vip.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff985146"]])

export default __exports__